import client from './client';

export {
  client,
};



// WEBPACK FOOTER //
// ./src/api/graphql/index.ts